module.exports = __webpack_public_path__ + "img/portraits_20_V.3236cf04.webp";